import React, { useState, useEffect, useCallback } from "react";
import { Modal, Box, IconButton, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import imageapi from "../../../../../../services/managelicense";
import {
  setEncryptedCookie,
  getDecryptedCookie,
  removeCookie,
} from "../../../../../../utils";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../../../../redux/loader/actions";

const EditImageModal = ({ open, onClose, businesssid, headerId }) => {
  const dispatch = useDispatch();
  const [savedImage, setSavedImage] = useState(null);
  const proid = getDecryptedCookie("proid");

  const getsavedimage = useCallback(() => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      if (res.data.status && res.data.file_url) {
        dispatch(hideLoader());
        setSavedImage(res.data.file_url);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Failed to fetch saved image", err);
    };

    imageapi.getimage(businesssid, headerId).then(onSuccess).catch(onFailure);
  }, [businesssid, headerId]);

  useEffect(() => {
    if (open) {
      getsavedimage();
    }
  }, [open, getsavedimage]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "80%", sm: "90%" },
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
          maxHeight: "80vh",
          overflow: "hidden",
        }}
      >
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Bill Header Image
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Typography>

        <Grid item xs={12}>
          {savedImage && savedImage.length > 0 ? (
            <Grid container spacing={2} justifyContent="center">
              {savedImage.map((image) => (
                <Grid
                  item
                  xs={4}
                  key={image.file_uuid}
                  display="flex"
                  justifyContent="center"
                >
                  <img
                    src={image.file_url}
                    alt="Image"
                    style={{
                      width: "160%",
                      height: "auto",
                      maxWidth: "186px",
                      objectFit: "cover",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>No images available</Typography>
          )}
        </Grid>
      </Box>
    </Modal>
  );
};

export default EditImageModal;
